<template>
    <router-link :to="linkToPage" class="block odd:bg-white even:bg-[#F7F9FC]" :class="classItem">
        <div class="p-4">
            <!-- Distributeur -->
            <p class="text-md text-primary">
                Distributeur :
                <span class="font-bold">
                    <template v-if="bouteille.fournisseur">{{ bouteille.fournisseur.nom }}</template>
                </span>
            </p>

            <!-- Titre + favori + badge info (si dispo via ta prop/info existante) -->
            <h2 class="text-xl mt-1">
                <template v-if="bouteille.favori && bouteille.favori.id === $user.id">
                    <i class="inline-block h-5 w-5 mask mask-star bg-yellow-400"></i>
                </template>
                Bouteille <span class="font-bold"><template v-if="bouteille.nom">{{ bouteille.nom.nom
                }}</template></span>

                <!-- Badge info orange selon ta condition existante -->
                <span v-if="bouteille.type !== 'Fluide frigorigène' && bouteille.poids_net !== 0 && info"
                    class="ml-2 inline-flex items-center text-xs px-2 py-1.5 rounded bg-[#ffedd4] text-[#ca3500]">
                    <i class="inline-block h-4 w-4 mask mask-recycle bg-[#ca3500] mr-1"></i>
                    {{ info }}
                </span>
            </h2>

            <!-- Ligne d'infos -->
            <div class="flex items-center gap-3 mt-3">
                <!-- Fluide (pastille colorée par TYPE de bouteille) -->
                <div v-if="bouteille.fluide"
                    class="flex items-center gap-1 px-3 py-1 rounded-r-full -ml-4 text-white text-sm font-medium"
                    :class="bouteille.type === 'Fluide frigorigène'
                        ? 'bg-gaz-ff'
                        : (bouteille.type === 'Récupération' ? 'bg-gaz-rec' : 'bg-gaz-tf')">
                    <i class="inline-block h-5 w-5 mask mask-snow bg-white"></i>
                    {{ bouteille.fluide.nom }}
                </div>

                <!-- Code bouteille -->
                <div class="flex items-center gap-1">
                    <i class="inline-block h-5 w-5 mask mask-bouteille" :class="bouteille.type === 'Fluide frigorigène'
                        ? 'bg-gaz-ff'
                        : (bouteille.type === 'Récupération' ? 'bg-gaz-rec' : 'bg-gaz-tf')"></i>
                    <span class="text-md font-medium" :class="bouteille.type === 'Fluide frigorigène'
                        ? 'text-gaz-ff'
                        : (bouteille.type === 'Récupération' ? 'text-gaz-rec' : 'text-gaz-tf')">{{ bouteille.code
                        }}</span>
                </div>

                <!-- OTAG -->
                <div v-if="bouteille.otag" class="flex items-center gap-1">
                    <i class="inline-block h-6 w-6 mask mask-otag" :class="bouteille.type === 'Fluide frigorigène'
                        ? 'bg-gaz-ff'
                        : (bouteille.type === 'Récupération' ? 'bg-gaz-rec' : 'bg-gaz-tf')"></i>
                    <span class="text-md font-medium" :class="bouteille.type === 'Fluide frigorigène'
                        ? 'text-gaz-ff'
                        : (bouteille.type === 'Récupération' ? 'text-gaz-rec' : 'text-gaz-tf')">{{ bouteille.otag
                        }}</span>
                </div>
            </div>

            <!-- Barre de niveau (si OTAG) -->
            <div v-if="bouteille.otag" class="mt-3">
                <div class="w-full bg-gray-200 rounded-full h-2">
                    <div class="h-2 rounded-full" :class="bouteille.type === 'Fluide frigorigène'
                        ? 'bg-gaz-ff'
                        : (bouteille.type === 'Récupération' ? 'bg-gaz-rec' : 'bg-gaz-tf')" :style="{
                            width:
                                (function () {
                                    var net = bouteille.poids_net ? bouteille.poids_net : 0;
                                    var max = bouteille.poids_max ? bouteille.poids_max : 0;
                                    var pct = max ? Math.min(100, Math.ceil((net * 100) / max)) : 0;
                                    return pct + '%';
                                })()
                        }"></div>
                </div>
                <p class="text-sm text-gray-600 mt-1">
                    {{ bouteille.poids_net ? bouteille.poids_net : 0 }} kg /
                    {{ bouteille.poids_max ? bouteille.poids_max : 0 }} kg
                </p>
            </div>
        </div>
    </router-link>
</template>
<script>

export default {
    props: {
        bouteille: {},
        info: {
            default: null
        }
    },
    computed: {
        styleObj() {
            return {
                width: Math.ceil(this.bouteille.poids_net * 100 / this.bouteille.poids_max) + '%'
            }
        },
        linkToPage() {
            return 'bouteille/' + this.bouteille.id
        },
        classItem() {
            switch (this.bouteille.type) {
                case 'Fluide frigorigène':
                    return 'ff';
                case 'Récupération':
                    return 'rec';
                case 'Transfert':
                    return 'tf';
            }
        }
    },
    methods: {

    }
}

</script>

<style>
.level-bar {
    display: block;
    position: relative;
}

.full-level {
    height: 10px;
    display: block;
    width: 100%;
    margin-top: 10px;
    background: #ccc;
    border-radius: 5px;
}

.level {
    position: absolute;
    top: -10px;
    left: 0;
    height: 10px;
    display: block;
    width: 0;
    margin-top: 10px;
    border-radius: 5px;
}

.ff .level {
    background-color: #999;
}

.ff:hover .level {
    background-color: #555555;
}

.rec .level {
    background-color: #86bc24;
}

.rec:hover .level {
    background-color: #55711c;
}

.tf .level {
    background-color: #5698d2;
}

.tf:hover .level {
    background-color: #335b7a;
}

a.item {
    display: block;
    padding: 10px;
    padding-right: 50px;
    margin-bottom: 5px;
    text-decoration: none;
    background-color: #eeeeee;
    transition: all 250ms ease;
}

a.item.hidden {
    display: none;
}

a.item:after {
    content: '\e909';
    font-family: 'fi360' !important;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    font-size: 3.3rem;
    position: absolute;
    right: 10px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
}

.favori {
    display: inline-flex;
    /* Remplacé inline-block par inline-flex */
    align-items: center;
    /* Aligne verticalement */
    justify-content: center;
    /* Centrage horizontal */
    gap: 6px;
    /* Espace entre l’icône et le texte */

    padding: 5px 10px;
    background-color: #f9d342;
    color: #222;
    font-weight: 600;
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    transition: background-color 0.3s, transform 0.2s;
    margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// BouteilleItem.vue?114bc782